// Copyright 2026. WebPros International GmbH. All rights reserved.

import axios from 'axios';
import { getUrl } from 'common/api/resources/Response';
import { IMeta } from 'common/api/resources/Meta/model';

export const meta = {
    get: () => axios.get<IMeta>(getUrl('/meta')),
};
